<!-- Translated: yes -->
<template>
  <div :class="{'only-collect-in-shop': !SITE_CONFIG.rental.delivery}">
    <div :class="{banner: true, quick: quick}">
      <h1>{{ $t('skirental.page.title') }}</h1>
    </div>
    <div class="content">

      <SkiRentalDiscount />

      <div class="offer-wrapper">

        <div class="offer-box without-delivery min-tablet" @click="openWithoutDelivery()">
          <div class="image blue">
            <icon name="hamta-sjalv" :scale="5" />
            <h2 v-if="SITE_CONFIG.rental.delivery" v-html="$t('skirental.book-and-pickup-with-br')"></h2>
            <h2 v-if="!SITE_CONFIG.rental.delivery">{{ $t('general.cta.book-thing', {thing: $t('general.equipment')}) }}</h2>
          </div>
          <div class="content">
            <p v-html="TEXTS['without-delivery-content-desktop']">
            </p>
            <div class="center">
              <button class="small" v-if="SITE_CONFIG.rental.delivery">{{ $t('skirental.book-and-pickup') }}</button>
              <button class="small" v-if="!SITE_CONFIG.rental.delivery">{{ $t('general.cta.book-thing', {thing: $t('general.equipment')}) }}</button>
            </div>
          </div>
        </div>

        <div class="offer-box with-delivery min-tablet" @click="openWithDelivery()" v-if="SITE_CONFIG.rental.delivery">
          <div class="image red">
            <icon name="utkorning" :scale="6" />
            <h2 v-html="$t('skirental.book-with-delivery-to-accomodation')"></h2>
          </div>
          <div class="content">
            <p v-html="TEXTS['with-delivery-content-desktop']">
            </p>
            <div class="center">
              <button class="small">{{ $t('skirental.book-with-delivery') }}</button>
            </div>
          </div>
        </div>

        <div class="items-list max-mobile" @click="openWithoutDelivery()">
          <div class="item">
            <div class="test">
              <div class="item-image blue"><icon name="hamta-sjalv" :scale="3.8" />
              </div>
            </div>
            <div class="item-body">
              <div class="">
                <h2 v-if="SITE_CONFIG.rental.delivery" v-html="$t('skirental.book-and-pickup-with-br')"></h2>
                <h2 v-if="!SITE_CONFIG.rental.delivery">{{ $t('general.cta.book-thing', {thing: $t('general.equipment')}) }}</h2>
                <div v-html="TEXTS['without-delivery-content-mobile']">
                </div>
              </div>

            </div>
            <div class="button-wrapper">
              <button class="small" v-if="SITE_CONFIG.rental.delivery">{{ $t('skirental.book-and-pickup') }}</button>
              <button class="small" v-if="!SITE_CONFIG.rental.delivery">{{ $t('general.cta.book-thing', {thing: $t('general.equipment')}) }}</button>
            </div>
          </div>
        </div>



        <div class="items-list max-mobile" @click="openWithDelivery()" v-if="SITE_CONFIG.rental.delivery">
          <div class="item">
            <div class="test">
              <div class="item-image"><icon name="utkorning" :scale="4" />
              </div>
            </div>
            <div class="item-body">
              <div class="">
                <h2 v-html="$t('skirental.book-with-delivery-to-accomodation')"></h2>
                <div v-html="TEXTS['with-delivery-content-mobile']">
                </div>
              </div>

            </div>
            <div class="button-wrapper red-button"><button class="small">{{ $t('skirental.book-with-delivery') }}</button></div>
          </div>
        </div>





      </div>
      <!--<p class="ingress" v-html="TEXTS['ingress']"></p>
      <div class="info-content" v-html="TEXTS['content']">
      </div>-->

      <div class="info-content" v-html="pageContent">
      </div>

    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';

import API from '@/classes/API';
import SkiRentalDiscount from '@/components/components/SkiRentalDiscount';

export default {
  components: {
    SkiRentalDiscount,
  },
  data() {
    return {
      TEXTS: {},
      pageContent: '',
      quick: false,
    };
  },
  computed: {
    ...mapGetters([
      'guidedRentals',
    ]),
  },
  mounted() {
    // this.setOffSite();
    if (this.$route.query.quick) {
      if (this.$route.query.delivery) {
        setTimeout(this.openWithDelivery, 1);
      } else {
        setTimeout(this.openWithoutDelivery, 1);
      }
      this.quick = true;
    } else {
      setTimeout(this.openWithoutDelivery, 1);
      this.quick = true;
    }

    this.getTexts();
  },
  methods: {
    ...mapMutations([
      'openModal',
      'closeModal',
      'setOffSite',
    ]),
    async getTexts() {
      const { data } = await API.get('texts/ski-rental');
      this.TEXTS = data;
      // const response = await API.get('page/rental');
      // this.pageContent = response;
    },
    openWithDelivery() {
      // const $this = this;
      // this.openModal(['GeneralModal', {
      //   title: 'Hämta själv',
      //   content: 'Denna funktion är tillfälligt avaktiverad här på webbplatsen.
      //   Välj "Boka och hämta utrustning själv" och ring sen gästservice på <a href="
      //   tel:054-13 26 00">054&#8209;13&nbsp;26&nbsp;00</a> för att boka utkörning
      //   till ditt boende.',
      //   ok: () => {
      //     $this.closeModal();
      //   },
      // }]);
      this.doTheOpening('with-delivery');
    },
    openWithoutDelivery() {
      this.doTheOpening('without-delivery');
    },
    doTheOpening(type) {
      /* if (this.guidedRentals.length) {
        const $this = this;
        this.openModal(['GeneralModal', {
          title: 'En omgång skidhyra',
          content: '<p>För tillfället går det endast hyra en omgång skidor.
          </p><p>Vill du se över vad du redan bokat?</p>',
          buttons: [
            {
              title: 'Avrbyt',
              class: 'border small white',
              click: () => {
                $this.closeModal();
              },
            },
            {
              title: 'Ändra nuvarande bokning',
              class: 'border small',
              click: () => {
                $this.closeModal();
                $this.$router.push({ name: 'ski rental overview' });
              },
            },
            {
              title: 'Ta bort tidigare bokning och gör om',
              class: 'border small white',
              click: () => {
                $this.closeModal();
                $this.openModal(['SkiRentalPickDate', {
                  type,
                }]);
              },
            },
          ],
        }]);
      } else { */
      this.openModal(['SkiRentalPickDate', {
        type,
      }]);
      // }
    },
  },
};
</script>

<style lang="stylus">
@import '~@/global.styl'

body
  background-color white
</style>

<style scoped lang="stylus">
@import '~@/global.styl'

.banner.quick
  height 100vh
  background-size cover
  background-image url(https://static.booking.branasgruppen.se/static/img/onsite-splash.jpg)
  background-position center
  position relative
  padding 0
  & > *
    display: none

.discount-offer
  margin 30px auto 0 auto
  +max-xs-mobile()
    margin-top 10px
    margin-bottom: 0

// .items-list
//   max-width 980px
//   margin 0 auto
//   width: 100%

//   .item
//     display: flex
//     justify-content: space-between
//     flex-gutter: 1em
//     background-color: white
//     box-shadow: 0 0 17px 0 rgba(0, 0, 0, 0.13)
//     padding: 15px 17px
//     cursor: pointer
//     margin-bottom: space-3
//     flex-wrap: wrap;
//     +max-mobile()
//       padding: 8px 8px 15px;
//       margin-top: 15px
//       margin-bottom: 15px

//     .button-wrapper
//       text-align: center
//       width: 100%
//       button
//         width: 60%

//     .test
//       width: 30%;
//       height: 100px;
//       background-size: cover
//       background-position: center center
//       background-image: url(https://static.booking.branasgruppen.se/static/img/utkorning-kort-bg.jpg)
//       +max-mobile()
//         width: 30%

//     .item-image
//       height: 100%
//       width: 100%
//       background-color: rgba(190,36,28,0.89)
//       text-align: center
//       position: relative;
//       &.blue
//         background-color: rgba(0,85,128,0.95)
//       .icon
//         position: absolute;
//         left: 50%;
//         top: 50%;
//         margin-left: -30px;
//         margin-top: -27px;

//     .item-body
//       flex-grow: 1
//       display: flex
//       flex-direction: column
//       justify-content: space-between
//       margin-left: space-2
//       padding: 10px 10px 0px 15px
//       +max-mobile()
//         width 70%
//         flex-grow: 0
//         margin-left 0

//     .buttons
//       width 100%
//       button
//         +max-mobile()
//           margin-top 0
//           margin-bottom 10px

//     h2
//       united-heavy()
//       uppercase()
//       font-size: size-font-headline-small
//       +max-mobile()
//         font-size: 17px

//     ul
//       +max-mobile()
//         margin-top 6px
//       li
//         font-size: size-font-2
//         margin-bottom: 12px
//         +max-mobile()
//           font-size 12px
//           margin-bottom: 6px

//     button
//       margin-top: space-2



.banner
  height 423px
  +max-mobile()
    height 180px
  background-size cover
  background-image url(https://static.booking.branasgruppen.se/static/img/toppbild-utrustning.jpg)
  background-position center
  position relative
  padding 0

//   h1
//     position absolute
//     bottom 0
//     left calc(50% - 300px)
//     width 600px
//     +max-screen(600px)
//       _padding = padding-mobile
//       left _padding
//       width "calc(100% - %s)" % (_padding * 2)
//     max-width 100%
//     padding 15px 5px
//     margin-bottom 0
//     background-color rgba(255, 255, 255, 0.92)
//     united-heavy()
//     uppercase()
//     centered()
//     font-size size-font-headline
//     +max-mobile()
//       font-size size-font-headline-mobile!important
//     color brick

// .ingress
//   max-width 674px
//   font-size 17px
//   font-weight bold
//   margin 25px auto
//   text-align center
//   +max-mobile()
//     text-align left
//     padding padding-mobile
//     font-size 15px
//     margin-top 0

// .offer-wrapper
//   display flex
//   justify-content space-between
//   max-width 980px
//   margin 0 auto
//   flex-wrap wrap
//   .only-collect-in-shop &
//     justify-content center

//   .offer-box
//     width 48%
//     background-color #ffffff
//     box-shadow 0 0 17px 0 rgba(0, 0, 0, 0.13)
//     padding 15px 17px
//     cursor pointer
//     margin-top: 40px
//     .only-collect-in-shop &
//       width 100%
//       max-width 480px
//     +max-mobile()
//       width 100%
//     .content
//       padding 8px 15px

//     ul
//       ul-with-checkboxes()
//       li
//         font-size: 14px!important

//     button
//       &.small
//         padding: 10px 15px 6px
//         font-size: 12px

//     .image
//       width 100%
//       height 240px
//       .only-collect-in-shop &
//         height 130px
//       background-size cover
//       flex-wrap wrap
//       centered()
//       padding-top 35px
//       +max-mobile()
//         padding-top 12px
//         height 75px
//         text-align left
//       .icon
//         .only-collect-in-shop &
//           display none
//         +max-mobile()
//           width: 45px !important;
//           height: 45px !important
//           font-size 10px !important;
//           float left
//           margin-left 20px
//       h2
//         united-heavy()
//         uppercase()
//         centered()
//         font-size size-font-headline
//         color white
//         width 100%
//         padding-top 5px
//         +max-mobile()
//           font-size 20px
//           text-align: left
//           padding-left 100px
//           padding-top 8px
//       &.red
//         background-image linear-gradient(rgba(190, 36, 28, 0.89), rgba(190, 36, 28, 0.89)), url(https://static.booking.branasgruppen.se/static/img/utkorning-kort-bg.jpg)
//       &.blue
//         background-image linear-gradient(rgba(0, 85, 128, 0.95), rgba(0, 85, 128, 0.95)), url(https://static.booking.branasgruppen.se/static/img/hamta-sjalv-kort-bg.jpg)
//         h2
//           padding-top 20px
//           +max-mobile()
//             padding-top 8px


//     ul
//       li
//         font-size size-font-2
//         margin-bottom 12px

//     button
//       margin-top space-2

</style>



// WEBPACK FOOTER //
// SkiRentalPage.vue?6b7d6578